export default "__VITE_ASSET__KPbfjF9O__"